import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PartsService {
  private uri = "";//`${environment.apiUrl}`;
  customerid = '';
  apiroute = '/FlexIntegration'

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.uri = this.appConfigService.apiBaseUrl;
    this.customerid = localStorage.getItem('customerid');
  }

  GetPartById(id) {
    console.log({ method: 'Get_AcctPartsDetailByIDCE', PARTid: id })
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_AcctPartsDetailByIDCE', PARTid: id });
  }

  GetPartByIdFlag(id){
    console.log({method: 'Get_AcctPartsDetailByIDCEMob',PARTid: id });
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_AcctPartsDetailByIDCEMob', PARTid: id });
  }

  InsertUpdate(data) {
    return this.http.post<any>(this.uri + this.apiroute, data);
  }

  Get_AcctPartsUOM(){
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_AcctPartsUOM'});
  }

  InsertUpdate_VendorPartsMultiple(vendorid,detailid, defaultvendor?){
    let obj: any = {
      method: 'InsertUpdate_VendorPartsMultiple',
      vendorid: vendorid,
      detailid: detailid,
    }
    if(defaultvendor){
      obj.default = defaultvendor;
    }
    console.log(obj)
    return this.http.post<any>(this.uri + this.apiroute, obj);
  }


  InsertDocument(file, id, doctype) {
    let obj = { filestring: file, doctype: doctype, id: id }
    console.log('Document string ', obj);
    return this.http.post(this.uri + '/DownloadFile/Upload', obj)
  }

  DowloadDocument(filepath): Observable<any> {
    return this.http.post(this.uri + '/DownloadFile/DownloadThumImg', { filename: filepath });
  }

  GetVendors(id) {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_VendorsForPartCE', partid: id });
  }

  GetVendorPartDetails(partid, vendorid){
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_AcctVendorPartsDetailByIDCE', PARTid: partid, VENDORid: vendorid });
  }

  GetVendorsAll() {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_VendorsAll' });
  }

  Get_VendorsAllActive() {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_VendorsAllActive' });
  }

  Get_Master_Vendors(){
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_Master_Vendors' });
  }

  GetPartType() {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_PartType' });
  }

  GetPartCategory() {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_PartCategory' });
  }

  GetPartTaskCategory() {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_TaskCategoryCE' });
  }

  GetPartsUOM() {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_AcctPartsUOM' });
  }

  GetPartHistory(id) {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_POPartHiostory', partid: id });
  }

  GetVendortHistory(id) {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_POPartHiostoryByVendorId', vendorid: id });
  }

  Get_PartCategoryNotCalsified() {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_PartCategoryNotCalsified' });
  }

  Get_PartCategoryCalsified() {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_PartCategoryCalsified' });
  }

  Get_PartCategory() {
    return this.http.post<any>(this.uri + this.apiroute, { method: 'Get_PartCategoryEditPart' });
  }

  IsertUdate_Add_ParttoCategory(partid, partcategoryid) {
    return this.http.post<any>(this.uri + this.apiroute, {
      method: 'IsertUdate_Add_ParttoCategory',
      partid: partid,
      partcategoryid: partcategoryid
    });
  }


}
